<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createAnnouncement') }}</h1>
      <div class="form-container">
        <AnnouncementForm @save="save"></AnnouncementForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import AnnouncementForm from '@/components/AnnouncementForm'

  export default {
    components: {
      DashboardLayout,
      AnnouncementForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Announcement/create', form).then(() => {
          this.$router.push({ name: 'announcements' })
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'announcements', path: 'announcements'},
          {name: 'createAnnouncement'}
        ]
      }
    }
  }
</script>
